<template>
  <el-dialog
    v-model="dialogVisible"
    title="选择模板"
    width="600px"
    :close-on-click-modal="false"
 >
    <el-form :model="searchForm" inline @submit.prevent="getDiyTemplateList">
      <el-form-item label="模板名称:">
        <el-input
          v-model="searchForm.name"
          placeholder="请输入模板名称"
          clearable
          size="small"
          @clear="getDiyTemplateList"
          @keyup.enter="getDiyTemplateList"
       />
      </el-form-item>
      <el-form-item>
        <el-button :loading="tableData.loading" type="primary" size="small" @click="getDiyTemplateList">
          搜索
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="tableData.loading" :data="tableData.data" size="small" max-height="500">
      <el-table-column prop="merId" label="模板ID">
        <template #default="{ row }">
          <el-radio v-model="currentSelectedId" :value="row.id" />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="模板名称" />
      <el-table-column prop="add_time" label="创建时间" />
    </el-table>
    <div class="block">
      <el-pagination
        v-model:current-page="searchForm.page"
        v-model:page-size="searchForm.limit"
        layout="prev, pager, next, jumper"
        :total="tableData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
     />
    </div>
    <template #footer>
      <div>
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { diyList } from '@/api/diy';

defineOptions({ name: 'diyTemplateSelect' });

const emit = defineEmits<{
 (e: 'confirm', id: number): void;
}>();

interface DiyRow {
  id: number;
  name?: string;
  add_time?: string;
}

const dialogVisible = ref(false);
const searchForm = reactive({
  name: '',
  page: 1,
  limit: 8,
});
const tableData = reactive({
  data: [] as DiyRow[],
  total: 0,
  loading: false,
});
const currentSelectedId = ref(0);

function handleSizeChange() {
  void getDiyTemplateList();
}

function handleCurrentChange() {
  void getDiyTemplateList();
}

function handleCancel() {
  dialogVisible.value = false;
}

function handleConfirm() {
  if (!currentSelectedId.value) {
    ElMessage.error('请选择模板');
    return;
  }
  emit('confirm', currentSelectedId.value);
  handleCancel();
}

async function getDiyTemplateList() {
  if (tableData.loading) return;
  tableData.loading = true;
  try {
    const res = await diyList(searchForm);
    const body = res as { data: { list: DiyRow[]; count: number } };
    tableData.data = body.data.list;
    tableData.total = body.data.count;
  } catch (error: unknown) {
    const msg = error instanceof Error ? error.message : String(error);
    ElMessage.error(msg);
  } finally {
    tableData.loading = false;
  }
}

function open(diyTemplateId?: number) {
  dialogVisible.value = true;
  currentSelectedId.value = diyTemplateId ?? 0;
}

onMounted(() => {
  void getDiyTemplateList();
});

defineExpose({ open });
</script>

<style scoped lang="scss"></style>
